'use strict';

var soloMultipliers = {
  debtMultiplier: 0,
  highAdditional: 1.625,
  highAnnual: 3.5,
  midAdditional: 2.25,
  midAnnual: 4.25,
  lowAdditional: 2.5,
  lowAnnual: 4.75
};
var couplesMultipliers = {
  debtMultiplier: 2.4,
  highAdditional: 1.25,
  highAnnual: 2.5,
  midAdditional: 1.75,
  midAnnual: 3.5,
  lowAdditional: 2,
  lowAnnual: 4
};
var hmcibTypes = {
  debtMultiplier: "number",
  highAdditional: "number",
  highAnnual: "number",
  midAdditional: "number",
  midAnnual: "number",
  lowAdditional: "number",
  lowAnnual: "number"
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

var throwTypeError = function throwTypeError(expected, actual) {
  throw new Error("Invalid type expected type ".concat(expected, " but received type ").concat(actual));
};

var checkTypes = function checkTypes(value, calcType) {
  Object.entries(value).map(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        k = _ref2[0],
        v = _ref2[1];

    return _typeof(v) === calcType[k] ? true : throwTypeError(calcType[k], _typeof(v));
  });
};

var calculate = function calculate(_ref) {
  var _ref$additionalIncome = _ref.additionalIncome,
      additionalIncome = _ref$additionalIncome === void 0 ? 0 : _ref$additionalIncome,
      _ref$income = _ref.income,
      income = _ref$income === void 0 ? 0 : _ref$income,
      _ref$debt = _ref.debt,
      debt = _ref$debt === void 0 ? 0 : _ref$debt;
  return function (_ref2) {
    var additionalMultiplier = _ref2.additionalMultiplier,
        annualMultiplier = _ref2.annualMultiplier,
        debtMultiplier = _ref2.debtMultiplier;
    var additionalIncomeMultiplied = additionalIncome * additionalMultiplier;
    var incomeMultiplied = income * annualMultiplier;
    var debtMultipled = debt * debtMultiplier;
    return Math.round(additionalIncomeMultiplied + incomeMultiplied - debtMultipled);
  };
};

var HmcibAmounts = function HmcibAmounts(values) {
  return function (_ref3) {
    var _ref3$income = _ref3.income,
        income = _ref3$income === void 0 ? 0 : _ref3$income,
        _ref3$additionalIncom = _ref3.additionalIncome,
        additionalIncome = _ref3$additionalIncom === void 0 ? 0 : _ref3$additionalIncom,
        _ref3$debt = _ref3.debt,
        debt = _ref3$debt === void 0 ? 0 : _ref3$debt;
    checkTypes(values, hmcibTypes);
    var debtMultiplier = values.debtMultiplier,
        highAdditional = values.highAdditional,
        highAnnual = values.highAnnual,
        midAdditional = values.midAdditional,
        midAnnual = values.midAnnual,
        lowAdditional = values.lowAdditional,
        lowAnnual = values.lowAnnual;
    var howLikely = calculate({
      additionalIncome: additionalIncome,
      income: income,
      debt: debt
    });
    var highlyLikely = howLikely({
      additionalMultiplier: highAdditional,
      annualMultiplier: highAnnual,
      debtMultiplier: debtMultiplier
    });
    var lessLikely = howLikely({
      additionalMultiplier: midAdditional,
      annualMultiplier: midAnnual,
      debtMultiplier: debtMultiplier
    });
    var unlikely = howLikely({
      additionalMultiplier: lowAdditional,
      annualMultiplier: lowAnnual,
      debtMultiplier: debtMultiplier
    });
    return {
      highlyLikely: highlyLikely,
      lessLikely: lessLikely,
      unlikely: unlikely
    };
  };
};

var HmcibCalculateSolo = HmcibAmounts(soloMultipliers);
var HmcibCalculateCouples = HmcibAmounts(couplesMultipliers);

var monthlyInterestRate = function monthlyInterestRate(rate, monthsPerYear) {
  return rate / monthsPerYear / 100;
};
var multiplyExponent = function multiplyExponent(x, y) {
  return Math.pow(x, y);
};
var getEquityPercentOfValue = function getEquityPercentOfValue(property, e) {
  return property * e / 100;
};
var calculateInterest = function calculateInterest(monthlyInterest, totalNumberOfPayments) {
  return monthlyInterest * multiplyExponent(1 + monthlyInterest, totalNumberOfPayments) / (multiplyExponent(monthlyInterest + 1, totalNumberOfPayments) - 1);
};
var numberOfPaymentPeriods = function numberOfPaymentPeriods(rate, pmt, pv) {
  // rate = interest rate
  // pmt = present monthly payment
  // pv = present value (balance)
  rate = parseFloat(rate);
  pmt = parseFloat(pmt);
  pv = parseFloat(pv);
  pv = -Math.abs(pv);
  var nperValue;
  rate = rate / 12;
  if (rate === 0) nperValue = -(0 + pv) / pmt;else nperValue = Math.log((-0 * rate + pmt) / (pmt + rate * pv)) / Math.log(1 + rate);
  return nperValue;
};
var calculateMonthlyRateCreditCard = function calculateMonthlyRateCreditCard(monthlyInterest) {
  var x = 0;

  if (!monthlyInterest > 0) {
    return x;
  }

  x = monthlyInterest / 100;
  x = Math.pow(x + 1, 1 / 12);
  x = (x - 1) * 100;
  return x >= 0 ? x : 0;
};

var utils = /*#__PURE__*/Object.freeze({
  monthlyInterestRate: monthlyInterestRate,
  multiplyExponent: multiplyExponent,
  getEquityPercentOfValue: getEquityPercentOfValue,
  calculateInterest: calculateInterest,
  numberOfPaymentPeriods: numberOfPaymentPeriods,
  calculateMonthlyRateCreditCard: calculateMonthlyRateCreditCard
});

var mortgageRepaymentTypes = {
  amountBorrowed: "number",
  deposit: "number",
  interestRate: "number",
  mortgageTerm: "number",
  mortgageTermMonths: "number",
  repaymentType: "string"
};

var MortgageMonthlyCostRepayment = function MortgageMonthlyCostRepayment(values) {
  checkTypes(values, mortgageRepaymentTypes);
  var _values$amountBorrowe = values.amountBorrowed,
      amountBorrowed = _values$amountBorrowe === void 0 ? 0 : _values$amountBorrowe,
      _values$deposit = values.deposit,
      deposit = _values$deposit === void 0 ? 0 : _values$deposit,
      _values$interestRate = values.interestRate,
      interestRate = _values$interestRate === void 0 ? 0 : _values$interestRate,
      _values$mortgageTerm = values.mortgageTerm,
      mortgageTerm = _values$mortgageTerm === void 0 ? 0 : _values$mortgageTerm,
      _values$mortgageTermM = values.mortgageTermMonths,
      mortgageTermMonths = _values$mortgageTermM === void 0 ? 0 : _values$mortgageTermM,
      repaymentType = values.repaymentType;
  var monthlyInterest = monthlyInterestRate(interestRate, 12);
  var totalNumberOfPayments = mortgageTerm * 12 + mortgageTermMonths;
  var calcInterest = calculateInterest(monthlyInterest, totalNumberOfPayments);
  var repaymentMonthlyCost = (amountBorrowed - deposit) * calcInterest;
  var interestOnlyCost = (amountBorrowed - deposit) * interestRate / 12 / 100;
  var mortgageAmount = amountBorrowed - deposit;

  if (repaymentType === "repayment") {
    return {
      monthly: repaymentMonthlyCost,
      mortgageAmount: mortgageAmount,
      interest: interestRate,
      totalRepayment: totalNumberOfPayments * repaymentMonthlyCost,
      term: mortgageTerm,
      termMonths: mortgageTermMonths,
      type: "repayment"
    };
  } else {
    return {
      monthly: interestOnlyCost,
      mortgageAmount: mortgageAmount,
      interest: interestRate,
      interestCost: totalNumberOfPayments * interestOnlyCost,
      totalRepayment: totalNumberOfPayments * interestOnlyCost + (amountBorrowed - deposit),
      term: mortgageTerm,
      termMonths: mortgageTermMonths,
      type: "interest-only"
    };
  }
};

var helpToBuyTypes = {
  propertyValue: 'number',
  deposit: 'number',
  interestRate: 'number',
  mortgageTerm: 'number',
  customInterest: 'number',
  equityLoanPercent: 'number'
};

var HelpToBuyCalculations = function HelpToBuyCalculations(values) {
  checkTypes(values, helpToBuyTypes);
  var _values$propertyValue = values.propertyValue,
      propertyValue = _values$propertyValue === void 0 ? 0 : _values$propertyValue,
      _values$deposit = values.deposit,
      deposit = _values$deposit === void 0 ? 0 : _values$deposit,
      interestRate = values.interestRate,
      _values$mortgageTerm = values.mortgageTerm,
      mortgageTerm = _values$mortgageTerm === void 0 ? 0 : _values$mortgageTerm,
      customInterest = values.customInterest,
      _values$equityLoanPer = values.equityLoanPercent,
      equityLoanPercent = _values$equityLoanPer === void 0 ? 0 : _values$equityLoanPer;
  var rate = interestRate || customInterest || 1;
  var monthlyInterest = monthlyInterestRate(rate, 12);
  var equityLoanValue = propertyValue / 100 * equityLoanPercent;
  var totalNumberOfPayments = mortgageTerm * 12;
  var calcInterest = calculateInterest(monthlyInterest, totalNumberOfPayments);
  var equityLoanReapymentMonthly = Math.round((propertyValue - (deposit + equityLoanValue)) * calcInterest);
  var equityLoanTotalValue = propertyValue / 100 * equityLoanPercent;
  var calcResults = MortgageMonthlyCostRepayment({
    amountBorrowed: propertyValue,
    deposit: deposit,
    interestRate: rate,
    mortgageTerm: mortgageTerm,
    repaymentType: 'repayment'
  });
  return _objectSpread2(_objectSpread2({}, calcResults), {}, {
    monthlyRepaymentWithEquityLoan: equityLoanReapymentMonthly,
    equityLoanTotalValue: equityLoanTotalValue
  });
};

var overpaymentTypes = {
  overBalance: "number",
  overTermYears: "number",
  overTermMonths: "number",
  overInterest: "number",
  overPaymentOne: "number",
  overPaymentMonth: "number",
  overpaymentType: "string"
};

var OverpaymentCalculations = function OverpaymentCalculations(values) {
  checkTypes(values, overpaymentTypes);
  var _values$overBalance = values.overBalance,
      overBalance = _values$overBalance === void 0 ? 0 : _values$overBalance,
      _values$overTermYears = values.overTermYears,
      overTermYears = _values$overTermYears === void 0 ? 0 : _values$overTermYears,
      _values$overTermMonth = values.overTermMonths,
      overTermMonths = _values$overTermMonth === void 0 ? 0 : _values$overTermMonth,
      _values$overInterest = values.overInterest,
      overInterest = _values$overInterest === void 0 ? 0 : _values$overInterest,
      _values$overpaymentTy = values.overpaymentType,
      overpaymentType = _values$overpaymentTy === void 0 ? "Both" : _values$overpaymentTy,
      _values$overPaymentOn = values.overPaymentOne,
      overPaymentOne = _values$overPaymentOn === void 0 ? 0 : _values$overPaymentOn,
      _values$overPaymentMo = values.overPaymentMonth,
      overPaymentMonth = _values$overPaymentMo === void 0 ? 0 : _values$overPaymentMo;
  var overInterestPercantage = overInterest / 100;
  var val1 = overBalance * (overInterestPercantage / 12);
  var val2 = 1 + overInterestPercantage / 12;
  var val3 = -Math.abs(overTermYears * 12 + overTermMonths);
  var val4 = 1 - Math.pow(val2, val3);
  var monthlyPayment = val1 / val4;
  var origMonths = numberOfPaymentPeriods(overInterestPercantage, monthlyPayment, overBalance);
  var origYears = origMonths / 12;
  var origInterest = origMonths * monthlyPayment - overBalance;
  if (overpaymentType == "One-off") overBalance = overBalance - overPaymentOne;else if (overpaymentType == "Recurring") monthlyPayment += overPaymentMonth;else if (overpaymentType == "Both") {
    overBalance = overBalance - overPaymentOne;
    monthlyPayment += overPaymentMonth;
  }
  var refinedMonths = numberOfPaymentPeriods(overInterestPercantage, monthlyPayment, overBalance);
  var refinedYears = refinedMonths / 12;
  var refinedInterest = refinedMonths * monthlyPayment - overBalance;
  var timeDiff = origYears - refinedYears;
  var overIntDiff = Math.round(origInterest - refinedInterest);
  var whole = Math.floor(timeDiff);
  var decimal = timeDiff - whole;
  var decNum = decimal * 12;
  decNum = Math.floor(decNum);
  var overTermDiff = whole + " years";
  if (decNum !== 0) overTermDiff += " and " + decNum + " months";
  return {
    origInterest: origInterest,
    refinedInterest: refinedInterest,
    overTermDiff: overTermDiff,
    overIntDiff: overIntDiff
  };
};

var CalculateEquity = function CalculateEquity(_ref) {
  var propertyWorth = _ref.propertyWorth,
      mortgage = _ref.mortgage,
      loans = _ref.loans;
  return propertyWorth - mortgage - loans;
};

var soloMultipliers$1 = {
  interest: 0.019
};
var hmcibAffordTypes = {
  interest: "number"
};

var HmcibAffordCalculate = function HmcibAffordCalculate(values) {
  return function (_ref) {
    var _ref$monthly = _ref.monthly,
        monthly = _ref$monthly === void 0 ? 0 : _ref$monthly,
        _ref$deposit = _ref.deposit,
        deposit = _ref$deposit === void 0 ? 0 : _ref$deposit,
        _ref$term = _ref.term,
        term = _ref$term === void 0 ? 0 : _ref$term;
    checkTypes(values, hmcibAffordTypes);
    var interest = values.interest;
    var val1 = 1 + interest / 12;
    var val2 = -Math.abs(term * 12);
    var val3 = Math.pow(val1, val2);
    var totalBorrow = parseInt(Math.round(monthly * ((1 - val3) / (interest / 12))));
    return {
      totalBorrow: totalBorrow,
      monthly: monthly,
      deposit: deposit,
      term: term
    };
  };
};

var HmcibAffordCalculateSolo = HmcibAffordCalculate(soloMultipliers$1);

var calculateMinimumRepayment = function calculateMinimumRepayment(balance, apr, minPercentage, minPayment) {
  var monthlyInterestRate = calculateMonthlyRateCreditCard(apr);
  var minRepayment = Math.ceil((minPercentage + monthlyInterestRate) * balance / 100);
  return Math.max(minPayment, minRepayment);
};

var calculateTotalInterestAndPeriod = function calculateTotalInterestAndPeriod(balance, apr, repayment) {
  var repayments, totalInterest, periods, workingBalance, interestPayment, interestRate, breakLoopPeriod; // 100 years

  breakLoopPeriod = 1200;
  totalInterest = repayments = periods = 0;
  interestRate = calculateMonthlyRateCreditCard(apr) / 100;
  workingBalance = balance;
  interestPayment = balance * interestRate;
  totalInterest += interestPayment;

  while (workingBalance + interestPayment > repayment) {
    workingBalance = workingBalance - repayment + interestPayment;
    interestPayment = workingBalance * interestRate;
    repayments += repayment;
    totalInterest += interestPayment;
    periods++;

    if (periods > breakLoopPeriod) {
      return {
        error: 'The payment period is higher than 100 years.'
      };
    }
  }

  return {
    interest: Math.ceil(totalInterest),
    period: periods > 0 ? periods + 1 : 1,
    total: balance + Math.ceil(totalInterest)
  };
};

var CalculateLoanRepayment = function CalculateLoanRepayment(_ref) {
  var amount = _ref.amount,
      apr = _ref.apr,
      term = _ref.term;
  var principal = amount;
  var interest = apr / 100 / 12;
  var payments = term * 12;
  var x = Math.pow(1 + interest, payments);
  var monthly = principal * x * interest / (x - 1);

  if (!isNaN(monthly) && monthly !== Number.POSITIVE_INFINITY && monthly !== Number.NEGATIVE_INFINITY) {
    var poundUKLocale = Intl.NumberFormat('en-UK');
    var monthlyPayment = poundUKLocale.format(round(monthly));
    var total = poundUKLocale.format(round(monthly * payments));
    var totalinterest = poundUKLocale.format(round(monthly * payments - principal));
    return {
      monthlyPayment: monthlyPayment,
      total: total,
      totalinterest: totalinterest
    };
  }
}; // This simple method rounds a number to two decimal places.

function round(x) {
  return Math.round(x * 100) / 100;
}

var index = {
  HmcibCalculateSolo: HmcibCalculateSolo,
  HmcibCalculateCouples: HmcibCalculateCouples,
  MortgageMonthlyCostRepayment: MortgageMonthlyCostRepayment,
  utils: utils,
  HelpToBuyCalculations: HelpToBuyCalculations,
  OverpaymentCalculations: OverpaymentCalculations,
  CalculateEquity: CalculateEquity,
  HmcibAffordCalculateSolo: HmcibAffordCalculateSolo,
  calculateMinimumRepayment: calculateMinimumRepayment,
  calculateTotalInterestAndPeriod: calculateTotalInterestAndPeriod,
  CalculateLoanRepayment: CalculateLoanRepayment
};

module.exports = index;
